<template>
  <v-chart :option="option" :autoresize="true" class="c-chart" />
</template>

<script>
import { use } from 'echarts/core'
import { SVGRenderer } from 'echarts/renderers'
import { LineChart } from 'echarts/charts'
import {
  GridComponent,
  TitleComponent,
  TooltipComponent,
  LegendComponent,
  DataZoomComponent,
  MarkLineComponent,
  DataZoomSliderComponent,
  DataZoomInsideComponent,
} from 'echarts/components'
import VChart, { THEME_KEY } from 'vue-echarts'

use([
  LineChart,
  SVGRenderer,
  GridComponent,
  TitleComponent,
  TooltipComponent,
  LegendComponent,
  DataZoomComponent,
  MarkLineComponent,
  DataZoomSliderComponent,
  DataZoomInsideComponent,
])

export default {
  name: 'HawaLineChart',
  components: {
    VChart,
  },
  provide: {
    [THEME_KEY]: 'light',
  },
  props: {
    Option: Object,
  },
  data() {
    return {
      option: {
        grid: {
          left: '40px',
          right: '40px',
        },
        series: [
          {
            data: [],
            type: 'line',
            smooth: true,
          },
        ],
      },
    }
  },

  created() {
    this.option = { ...this.option, ...this.Option }
  },

  watch: {
    Option: {
      deep: true,
      handler: function() {
        this.option = { ...this.option, ...this.Option }
      },
    },
  },
}
</script>

<style scoped>
.c-chart {
  height: 400px;
  width: 100%;
}
</style>
